/* eslint-disable prefer-object-spread */
import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance'; 
import executor from   '../../../data/axiosInstance/executor';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

const initialState = {
  events: [],
  // Lazy-load per tab (WS-1): l'agenda si carica solo all'apertura del tab.
  eventsLoaded: false,
  eventsLoading: false
};

export const EventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    getEvents: (state, action) => {
      state.events = [];
      state.events = action.payload;
    },
    setEventsLoading: (state, action) => {
      state.eventsLoading = action.payload;
    },
    setEventsLoaded: (state, action) => {
      state.eventsLoaded = action.payload;
    },
    resetEventsLoaded: (state) => {
      state.eventsLoaded = false;
    }
  }
});

export const { getEvents, setEventsLoading, setEventsLoaded, resetEventsLoaded } = EventSlice.actions;

/*
const currentYear = new Date().getFullYear();
const parseAdjust = (eventDate) => {
  const date = new Date(eventDate);
  date.setFullYear(currentYear);
  return date;
};*/
 

export const fetchEvents = (force = false) => async (dispatch, getState) => {
  const { eventsLoaded, eventsLoading } = getState().eventsReducer;
  if (!force && (eventsLoaded || eventsLoading)) return null;

  dispatch(setEventsLoading(true));
  try {
    const API_URI_CALL = `${API_URL}/api/v1/bff/task/lista/agenda`;

    const fetchData = async  () => axiosInstance.get(API_URI_CALL);

    const [res, err] = await executor.executeAsync(fetchData);

    console.log('res',res);
    console.log('err',err);
    if (err) return true;

    dispatch(getEvents(res.data));
    dispatch(setEventsLoaded(true));
    return res.data;
  } finally {
    dispatch(setEventsLoading(false));
  }
};

export default EventSlice.reducer;
